var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 17.3333C4.39758 17.3333 0.666748 13.6025 0.666748 9C0.666748 4.3975 4.39758 0.666668 9.00008 0.666668C13.6026 0.666668 17.3334 4.3975 17.3334 9C17.3334 13.6025 13.6026 17.3333 9.00008 17.3333ZM9.00008 15.6667C10.7682 15.6667 12.4639 14.9643 13.7141 13.714C14.9644 12.4638 15.6667 10.7681 15.6667 9C15.6667 7.23189 14.9644 5.5362 13.7141 4.28596C12.4639 3.03571 10.7682 2.33333 9.00008 2.33333C7.23197 2.33333 5.53628 3.03571 4.28604 4.28596C3.03579 5.5362 2.33341 7.23189 2.33341 9C2.33341 10.7681 3.03579 12.4638 4.28604 13.714C5.53628 14.9643 7.23197 15.6667 9.00008 15.6667ZM8.16675 4.83333H9.83341V6.5H8.16675V4.83333ZM8.16675 8.16667H9.83341V13.1667H8.16675V8.16667Z",
    fill: "#0E0A42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.b556e72bb412aab72d532a6a643c57b5.svg";
export { ForwardRef as ReactComponent };